import { Divider } from '@mui/material';
import MuiBreadcrumbs from '@mui/material/Breadcrumbs';
import { styled } from '@mui/system';

import { THEME_GRID_SPACING } from '@config/theme';

export const layoutBreadcrumbsLinkSX = {
  display: 'flex',
  whiteSpace: 'nowrap',
  color: 'grey.900',
  textDecoration: 'none',
  alignContent: 'center',
  alignItems: 'center',
  '&:hover': {
    textDecoration: 'underline',
  },
};

export const layoutBreadcrumbsTitleTypographySX = {
  display: 'flex',
  textDecoration: 'none',
  whiteSpace: 'nowrap',
  alignContent: 'center',
  alignItems: 'center',
  color: 'grey.500',
};

export const LayoutBreadcrumbsMuiBreadcrumbsStyled = styled(MuiBreadcrumbs)(
  ({ theme }) => ({
    '& .MuiBreadcrumbs-separator': {
      width: 16,
      marginLeft: theme.spacing(1.25),
      marginRight: theme.spacing(1.25),
    },
    '& .MuiBreadcrumbs-ol': {
      flexWrap: 'nowrap',
    },
  })
);

export const LayoutBreadcrumbsDividerStyled = styled(Divider)(({ theme }) => ({
  borderColor: theme.palette.primary.main,
  marginBottom: theme.spacing(THEME_GRID_SPACING),
}));
